import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/grimace': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8C111 8 0 119 0 256S111 504 248 504 496 393 496 256 385 8 248 8zM248 456C137.7 456 48 366.3 48 256S137.7 56 248 56 448 145.7 448 256 358.3 456 248 456zM168 240C185.7 240 200 225.7 200 208S185.7 176 168 176 136 190.3 136 208 150.3 240 168 240zM328 240C345.7 240 360 225.7 360 208S345.7 176 328 176 296 190.3 296 208 310.3 240 328 240zM344 256H152C125.5 256 104 277.5 104 304V336C104 362.5 125.5 384 152 384H344C370.5 384 392 362.5 392 336V304C392 277.5 370.5 256 344 256zM176 352H152C143.2 352 136 344.8 136 336V328H176V352zM176 312H136V304C136 295.2 143.2 288 152 288H176V312zM240 352H192V328H240V352zM240 312H192V288H240V312zM304 352H256V328H304V352zM304 312H256V288H304V312zM360 336C360 344.8 352.8 352 344 352H320V328H360V336zM360 312H320V288H344C352.8 288 360 295.2 360 304V312z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/grimace.js
// module id = 2F3q
// module chunks = 144